@if (totalItems > 0) {
  <nav class="mt-1 flex items-center justify-between gap-3" role="navigation">
    <ul class="flex items-center gap-1">
      <li>
        <ag1-button-small
          [variant]="currentPage === buttonOneNumber ? 'primary' : 'tertiary'"
          (clickEvent)="goToPage(buttonOneNumber)"
        >
          {{ buttonOneNumber }}
        </ag1-button-small>
      </li>
      @if (this.lastPageNumber > 1) {
        <li>
          <ag1-button-small
            [variant]="currentPage === buttonTwoNumber ? 'primary' : 'tertiary'"
            (clickEvent)="goToPage(buttonTwoNumber)"
          >
            {{ buttonTwoNumber }}
          </ag1-button-small>
        </li>
      }
      @if (this.lastPageNumber > 2) {
        <li>
          <ag1-button-small
            [variant]="
              currentPage === buttonThreeNumber ? 'primary' : 'tertiary'
            "
            (clickEvent)="goToPage(buttonThreeNumber)"
          >
            {{ buttonThreeNumber }}
          </ag1-button-small>
        </li>
      }
      <li>Page {{ currentPage }} of {{ lastPageNumber }}</li>
    </ul>
    <div class="flex items-center gap-1">
      @if (currentPage > 1 && lastPageNumber > 1) {
        <ag1-button-small variant="tertiary" (clickEvent)="goToPage(1)">
          First
        </ag1-button-small>
      }
      <ag1-button-small
        variant="tertiary"
        (clickEvent)="goToPage(currentPage - 1)"
        [disabled]="!canGoPrevious"
      >
        Previous
      </ag1-button-small>
      <ag1-button-small
        variant="tertiary"
        (clickEvent)="goToPage(currentPage + 1)"
        [disabled]="!canGoNext"
      >
        Next
      </ag1-button-small>
      @if (currentPage !== lastPageNumber && lastPageNumber > 1) {
        <ag1-button-small
          variant="tertiary"
          (clickEvent)="goToPage(lastPageNumber)"
        >
          Last
        </ag1-button-small>
      }
    </div>
  </nav>
}
